// test2072
(2072 && 0);
